import http from '@/api/HttpHelper'

const state = {
    missing_cp303: [],
    missing_r0901: [],
    loading: false
}

const getters = {
    missingCp303 (state) {
        return state.missing_cp303
    },
    missingR0901 (state) {
        return state.missing_r0901
    },
    countCp303 (state) {
        return state.missing_cp303.length
    },
    countR0901 (state) {
        return state.missing_r0901.length
    },
    totalMissingCount (state) {
        return state.missing_cp303.length + state.missing_r0901.length
    },
    loading (state) {
        return state.loading
    }
}

const mutations = {
    cp_data (state, data) {
        state.missing_cp303 = data
    },
    r0901_data (state, data) {
        state.missing_r0901 = data
    },
    setLoading (state, isLoading) {
        state.loading = isLoading
    }
}

const actions = {
    async getMissingMappings ({ dispatch }) {
        dispatch('getMissingFromService', 'cp')
        dispatch('getMissingFromService', 'r0901')
    },
    async getMissingFromService ( { commit }, report) {
        commit('setLoading', true)
        var result = await http.get(`missingmapping/${report}`)
        commit(`${report}_data`, result.data)
        commit('setLoading', false)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}